import { NavRoute } from '../shared/navigation/nav.route.interface';
import { getAdminNav } from './nav-areas/admin-nav';
import { getReportsNav } from './nav-areas/reports-nav';
import { getNavientNav } from './nav-areas/navient-nav';
import { getClientNav } from './nav-areas/client-nav';
import { getNixiesNav } from './nav-areas/nixies-nav';

export const getMainNavRoutes: () => NavRoute[] = function () {
	return [
		// { name: 'Home', path: '', exact: true, security: sec => sec === null  },
		// { name: 'Login', path: 'login', exact: true, security: sec => sec === null  },
		getNavientNav(),
		getClientNav(),
		getNixiesNav(),
		getAdminNav(),
		getReportsNav(),
	];
};
